import { useAppStore } from "@hooks/useAppStore";
import { isStaging } from "@memorang/constants/src/urls";

const STAGING_MIXPANEL_SECRET_KEY = "fa9c619bbdd5631c565a957a1bc0b1b5";
const SEGMENT_STAGING_API_KEY = "grXlDpeI4Si8h85BJ7akNfNiENft0AgU"; // https://app.segment.com/memorang-dev-services-segment/sources/mobile-app-react-native/settings/keys

const AnalyticsDestinationType = {
	Mixpanel: "mixpanel",
	Segment: "segment",
} as const;
type AnalyticsDestinationTypeKeys =
	(typeof AnalyticsDestinationType)[keyof typeof AnalyticsDestinationType];

const isProduction = process.env.NODE_ENV === "production" && !isStaging;

// Get all analytics destinations from the local state, adding the legacy mixpanel destination if it exists and isn't already in the array of analyticsDestinations for
// backwards compatibility
const getAnalyticsDestinations = () => {
	if (!isProduction) {
		return [
			{
				type: AnalyticsDestinationType.Mixpanel,
				apiKey: STAGING_MIXPANEL_SECRET_KEY,
			},
			{
				type: AnalyticsDestinationType.Segment,
				apiKey: SEGMENT_STAGING_API_KEY,
			},
		];
	}

	// Get the analytics destinations from the local state
	const analyticsDestinations =
		useAppStore.getState().app.analytics?.analyticsDestinations || [];

	// If the mixpanel destination exists and isn't already in the array of analyticsDestinations, add it for backwards compatibility
	if (
		useAppStore.getState().app.analytics.mixpanel &&
		!analyticsDestinations.find(
			(destination) =>
				destination.apiKey === useAppStore.getState().app.analytics.mixpanel.id,
		)
	) {
		analyticsDestinations.push({
			type: AnalyticsDestinationType.Mixpanel,
			apiKey: useAppStore.getState().app.analytics.mixpanel.id,
		});
	}

	return analyticsDestinations;
};

export {
	getAnalyticsDestinations,
	AnalyticsDestinationType,
	type AnalyticsDestinationTypeKeys,
};
